import { render, staticRenderFns } from "./PendencyMomentXForm.vue?vue&type=template&id=7a961927&scoped=true"
import script from "./PendencyMomentXForm.vue?vue&type=script&lang=js"
export * from "./PendencyMomentXForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PendencyMomentXForm.vue?vue&type=style&index=1&id=7a961927&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a961927",
  null
  
)

export default component.exports